import React, { useRef } from 'react'
import View from './view.js'
import useMaskedInput from '@local/use-masked-input'

let MASKS = {
  date: {
    mask: [/[0-1]/, /\d/, '/', /[0-3]/, /\d/, '/', /[1-2]/, /\d/, /\d/, /\d/],
    guide: true,
  },
  phone: {
    mask: [
      '(',
      /[1-9]/,
      /\d/,
      /\d/,
      ')',
      ' ',
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
      /\d/,
      /\d/,
    ],
    guide: true,
  },
  twoDigits: {
    mask: [/\d/, /\d/],
    guide: false,
  },
  fiveDigits: {
    mask: [/\d/, /\d/, /\d/, /\d/, /\d/],
    guide: true,
  },
}

export default function Logic(props) {
  let input = useRef(null)

  if (process.env.REACT_APP_ENV === 'development' && !(props.mask in MASKS)) {
    throw new Error(
      `${props.mask} isn't a valid mask. Choose from ${Object.keys(MASKS)}`
    )
  }

  let onChange = useMaskedInput({
    input,
    ...MASKS[props.mask],
    onChange: event => props.onChange(event.target.value),
    value: props.initialValue,
  })

  return (
    <View
      {...props}
      innerRef={input}
      onChange={onChange}
      onKeyUp={event => {
        if (event.key === 'Enter' && typeof props.onSubmit === 'function') {
          props.onSubmit()
        }
      }}
      onSubmit={props.onSubmit}
    />
  )
}
Logic.defaultProps = {
  mask: 'phone',
  initialValue: '',
}
